import React, { Component } from 'react';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { arrayMoveImmutable } from 'array-move'; // Importación corregida
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion, setImagesUploader } from '../../../../actions/publicacionesActions';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

// Componente para cada imagen individual
const SortableItem = SortableElement(({ image, onDelete }) => (
    <div style={{ margin: '10px' }}>
        <div style={{ margin: '10px' }}>
            <img
                src={image.urlImagen}
                alt={image.name}
                style={{
                    width: '250px',
                    height: 'auto',
                    maxHeight: '250px',
                    objectFit: 'contain',
                    marginRight: '10px' // Espacio entre la imagen y el botón
                }}
            />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button className="btn btn-light" onClick={onDelete} style={{ width: '40px', height: '40px' }}>
                <i className="fas fa-trash-alt" style={{ pointerEvents: 'none' }} ></i>
            </button>
        </div>
    </div>
));

// Componente para la lista de imágenes
const SortableList = SortableContainer(({ items, onDelete }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {(items || []).map((image, index) => {
            image.posicion = index; // Modificación directa del objeto
            return (
                <SortableItem
                    key={image.urlImagen || `item-${index}`}
                    index={index}
                    image={image}
                    onDelete={(e) => {
                        e.preventDefault();
                        onDelete(image);
                    }}
                />
            );
        })}
    </div>
));

// Componente principal basado en clase
class ImageUploader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: [],
        };
    }

    componentDidMount() {
        if (!this.state.images.length) {
            this.setState({ images: this.props.publicacion.imagenes || [] });
        }
    }

    // Maneja la carga de nuevas imágenes
    handleImageUpload = (event) => {
        const files = Array.from(event.target.files);
        const image = event.target.files[0];

        // 500 KB en bytes
        if (image.size > 512000) {
            toast.error("Tamaño de imagen debe ser menor a 500kb");
            return;
        }

        const newImages = files.map((file) => ({
            urlImagen: URL.createObjectURL(file),
            name: file.name,
            posicion: (this.state.images || []).length,
            imagen: file
        }));
        this.setState(
            (prevState) => ({
                images: [...(prevState.images || []), ...newImages],
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };

    // Maneja la reorganización de imágenes
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(
            (prevState) => ({
                images: arrayMoveImmutable(prevState.images || [], oldIndex, newIndex),
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };

    // Maneja la eliminación de imágenes
    handleDeleteImage = (imageToDelete) => {
        URL.revokeObjectURL(imageToDelete.urlImagen);

        this.setState(
            (prevState) => ({
                images: (prevState.images || []).filter((image) => image !== imageToDelete),
            }),
            () => {
                this.props.setImagesUploader(this.state.images, true);
            }
        );
    };


    render() {
        const { images } = this.state;

        return (
            <div>
                <input
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={this.handleImageUpload}
                    style={{ marginBottom: '20px' }}
                />
                <SortableList
                    items={images}
                    onSortEnd={this.onSortEnd}
                    axis="xy"
                    onDelete={this.handleDeleteImage}
                />
            </div>

        );
    }
}
ImageUploader.propTypes = {
    // Redux props
    publicacion: PropTypes.shape({
        imagenes: PropTypes.array,
        idPublicacion: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    // Actions props
    setImagesUploader: PropTypes.func,
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
    userId: state.general.userId,
    imagesUploader: state.publicaciones.imagesUploader,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion, setImagesUploader })(ImageUploader);